import { trackCdp, trackEvent, trackGA } from 'utilities/tracking';

window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.AccessoriesShow.init());

Sq.Shop.AccessoriesShow = {
  utils: Sq.Shop.Utils,
  pageId: '#accessories-show-page',

  init() {
    if ($(this.pageId).length === 0) {
      return;
    }

    this.getHtml();
    this.bindEvents();
    this.onPageView();
  },

  getHtml() {
    this.$page = $(this.pageId);
  },

  bindEvents() {
    this.$page.on('click', `[${this.utils.PRODUCT_DATA_ATTR}]`, (e) =>
      this.onProductClick(e)
    );
  },

  onPageView() {
    // Track
    this.utils.trackProductList(this.$page, {
      listName: 'Accessories',
      impression: true,
    });
  },

  onProductClick(e) {
    const product = this.utils.productData(e.currentTarget);
    product.list = 'Accessories';

    trackGA('ec:addProduct', product);
    trackGA('ec:setAction', 'click', { list: 'Accessories' });
    trackEvent({
      name: 'Product',
      value: 'Click',
      params: product,
    });
    trackCdp({
      name: 'Click Product',
      params: {
        feature: 'shop',
        sku: product.sku,
      },
    });
  },
};
